import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Pimprichichwadtomumbaicab() {



const cardData = {
  keyword: " Pimpri Chinchwad to Mumbai Cab   ",

headingDescription:
  "Velocity Cab offers dependable and comfortable Pimpri Chinchwad to Mumbai cab services for all your travel needs. Whether you are planning a business trip, airport transfer, family outing, weekend getaway, or leisure travel, our professional drivers and well‑maintained vehicles ensure a smooth and stress‑free journey from Pimpri Chinchwad to Mumbai. We provide flexible booking options including one‑way rides, round trips, and customized travel plans with transparent pricing and no hidden charges. Our diverse fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate groups. With easy online booking, punctual pickups from any location in Pimpri Chinchwad, and 24/7 customer support, Velocity Cab is your trusted choice for cab travel to Mumbai.",

topPlaces: [
 
  {
    title: "Hanging Gardens",
    description: "The Hanging Gardens on Malabar Hill offer beautifully landscaped gardens with panoramic views of Marine Drive and the Arabian Sea. Travelers booking an Innova Crysta on rent in Pune can relax amidst lush greenery, enjoy peaceful walks, and capture stunning city views from one of Mumbai's most scenic locations."
  },
  {
    title: "Bandra Fort",
    description: "Bandra Fort, also known as Castella de Aguada, is a historic Portuguese fort overlooking the Bandra-Worli Sea Link. Visitors traveling with an Innova Crysta on rent in Pune can enjoy a comfortable drive to this heritage site while exploring breathtaking sea views, photography spots, and Mumbai's rich colonial history."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a peaceful urban lake surrounded by modern buildings, gardens, and cafés. Travelers renting an Innova Crysta in Pune can enjoy a comfortable road trip before spending quality time by the lakeside, boating, dining, or simply relaxing with family and friends in a scenic environment."
  },
  {
    title: "Mahalakshmi Temple",
    description: "Mahalakshmi Temple is one of Mumbai's oldest and most revered Hindu temples dedicated to Goddess Mahalakshmi. Choosing an Innova Crysta on rent in Pune ensures a comfortable journey for pilgrims and tourists visiting this sacred temple while also exploring nearby coastal viewpoints and local markets."
  },
  {
    title: "Film City, Goregaon",
    description: "Film City in Goregaon is the heart of Mumbai's film and television industry. Travelers hiring an Innova Crysta on rent in Pune can comfortably visit this famous attraction, where guided tours showcase movie sets, shooting locations, lush greenery, and behind-the-scenes experiences of Bollywood filmmaking."
  },
   {
    title: "Colaba Causeway",
    description: "Colaba Causeway is one of Mumbai's most famous shopping and dining streets, offering everything from fashion accessories to local handicrafts and cafés. Travelers booking an Innova Crysta on rent in Pune can comfortably reach this vibrant destination and enjoy shopping, street food, and the lively atmosphere. It is an ideal stop for families, couples, and groups exploring South Mumbai."
  },
  {
    title: "Girgaon Chowpatty",
    description: "Girgaon Chowpatty is a popular public beach known for its festive atmosphere and delicious Mumbai street food. Renting an Innova Crysta in Pune makes the road trip comfortable for families and friends planning a relaxing day by the sea. Visitors can enjoy beautiful sunsets, local snacks like pav bhaji and bhel puri, and various cultural celebrations."
  },
  {
    title: "Nehru Planetarium",
    description: "Nehru Planetarium is an educational attraction that offers fascinating astronomy shows and interactive exhibits. Travelers choosing an Innova Crysta on rent in Pune can enjoy a hassle-free drive to this destination, making it an excellent place for students, families, and science enthusiasts interested in space exploration."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is a magnificent meditation monument located near Gorai in Mumbai. Visitors hiring an Innova Crysta on rent in Pune can comfortably travel to this peaceful destination to admire its grand golden dome, meditation halls, and serene surroundings. It is perfect for spiritual retreats and peaceful sightseeing."
  },
  {
    title: "Kanheri Caves",
    description: "Kanheri Caves are ancient Buddhist rock-cut caves situated inside Sanjay Gandhi National Park. Renting an Innova Crysta in Pune allows travelers to enjoy a smooth journey before exploring centuries-old sculptures, prayer halls, and historical carvings. The destination is ideal for history lovers, photographers, and adventure seekers."
  },
],



services: [
{
name: "Pimpri Chinchwad to Mumbai Airport Cab",
description: "Pimpri Chinchwad to Mumbai Airport cab service offers reliable transportation for passengers traveling from PCMC to Mumbai Airport terminals. Comfortable vehicles with professional drivers ensure safe journeys via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, and railway stations across Pimpri, Chinchwad, and PCMC areas. Vehicles provide comfortable seating and luggage space suitable for airport travel. Flexible booking options allow convenient airport cab reservations."
},
{
name: "Pimpri to Mumbai Airport Cab Charges",
description: "Pimpri to Mumbai Airport cab charges services provide transparent fare information for travelers planning airport transfers from Pimpri to Mumbai Airport. Pricing includes vehicle type, toll charges, and driver allowance details. Vehicles are well maintained and suitable for long-distance highway travel. Pickup services are available from homes, offices, and hotels across Pimpri. Flexible booking options allow convenient ride planning."
},
{
name: "Pimpri Chinchwad to Mumbai One Way Cab",
description: "Pimpri Chinchwad to Mumbai one way cab service offers convenient single-trip transportation for passengers traveling between PCMC and Mumbai. Vehicles are comfortable and suitable for highway travel with professional drivers ensuring safe journeys via the expressway. Pickup services are available from homes, offices, hotels, and railway stations. Flexible booking options allow quick one-way ride reservations."
},
{
name: "PCMC to Mumbai Taxi Service",
description: "PCMC to Mumbai taxi service provides dependable transportation for passengers traveling between Pimpri Chinchwad and Mumbai city. Professional drivers ensure safe and punctual journeys along the expressway. Vehicles are comfortable and suitable for business trips, tourism travel, and airport transfers. Pickup services are available from homes, offices, hotels, and railway stations across PCMC. Flexible booking options allow convenient taxi reservations."
},
{
name: "PCMC to Mumbai Drop Taxi Service",
description: "PCMC to Mumbai drop taxi service offers reliable one-way transportation for passengers traveling from Pimpri Chinchwad to Mumbai. Vehicles are well maintained and suitable for long-distance highway travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, and railway stations across PCMC. Flexible booking options allow quick drop taxi reservations."
},
{
name: "Pimpri Chinchwad to Mumbai Innova Taxi Fare",
description: "Pimpri Chinchwad to Mumbai Innova taxi fare services provide pricing details for premium SUV travel between PCMC and Mumbai. Innova vehicles offer spacious seating and smooth ride quality suitable for highway journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, and railway stations across Pimpri Chinchwad. Flexible booking options allow easy ride reservations."
},
{
name: "Chinchwad to Mumbai Airport Cab",
description: "Chinchwad to Mumbai Airport cab service provides convenient transportation for passengers traveling from Chinchwad to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport journeys. Professional drivers ensure safe and punctual expressway travel. Pickup services are available from homes, offices, hotels, and railway stations across Chinchwad. Flexible booking options allow convenient airport cab reservations."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation for passengers traveling between Pune and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for expressway travel. Professional drivers ensure safe driving and punctual pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient SUV ride reservations."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for comfortable long-distance travel. Innova vehicles offer spacious seating and smooth ride quality ideal for expressway journeys. Professional drivers ensure safe driving and punctual pickup services across Pune and Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient ride reservations."
},
{
name: "Pimpri Chinchwad to Mumbai Cab Booking",
description: "Pimpri Chinchwad to Mumbai cab booking service allows travelers to easily reserve comfortable vehicles for highway journeys between PCMC and Mumbai. Online booking options help passengers confirm rides quickly with transparent pricing. Vehicles are well maintained and suitable for long-distance travel. Flexible booking options allow convenient ride reservations."
},
{
name: "Chinchwad to Mumbai Cab",
description: "Chinchwad to Mumbai cab service provides reliable transportation for passengers traveling between Chinchwad and Mumbai city. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, and railway stations across Chinchwad. Flexible booking options allow easy cab reservations."
},
{
name: "Chinchwad to Mumbai Airport Drop",
description: "Chinchwad to Mumbai Airport drop service offers convenient one-way transportation for passengers traveling to Mumbai Airport terminals. Vehicles are comfortable and suitable for airport journeys with professional drivers ensuring punctual pickup services. Pickup services are available from homes, offices, hotels, and railway stations across Chinchwad. Flexible booking options allow easy airport ride reservations."
},
{
name: "Pimpri Chinchwad to Mumbai Cab Booking Online",
description: "Pimpri Chinchwad to Mumbai cab booking online service allows travelers to quickly reserve taxis for intercity travel through online platforms. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, and railway stations across PCMC. Flexible booking options allow convenient ride scheduling."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for local travel, airport transfers, and outstation journeys. Well-maintained vehicles and professional drivers ensure safe and comfortable rides across the city and nearby destinations. Pickup services are available from homes, offices, hotels, and railway stations. Flexible booking options allow convenient taxi reservations."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service offers reliable airport transportation for passengers traveling to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport travel. Professional drivers ensure safe driving and punctual pickup services across Pune. Flexible booking options allow convenient airport ride reservations."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service offers dependable transportation between Pune and Mumbai via the expressway. Comfortable vehicles with professional drivers ensure safe and smooth highway journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow easy ride reservations."
},
{
name: "Pimpri Chinchwad to Mumbai Cab",
description: "Pimpri Chinchwad to Mumbai cab service provides convenient transportation for passengers traveling between PCMC and Mumbai. Vehicles are suitable for long-distance highway travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, and railway stations across Pimpri Chinchwad. Flexible booking options allow easy cab reservations."
},
{
name: "Pimpri Chinchwad to Mumbai Taxi",
description: "Pimpri Chinchwad to Mumbai taxi service offers reliable transportation with comfortable vehicles and professional drivers. Passengers can travel safely between PCMC and Mumbai via the expressway with punctual pickup services. Pickup services are available from homes, offices, hotels, and railway stations. Flexible booking options allow convenient taxi reservations."
},
{
name: "Pimpri Chinchwad to Mumbai Cab Service",
description: "Pimpri Chinchwad to Mumbai cab service provides comfortable transportation for passengers traveling between PCMC and Mumbai. Vehicles are well maintained and suitable for long-distance highway travel. Professional drivers ensure safe driving and punctual pickup services. Flexible booking options allow convenient ride reservations."
},
{
name: "Pimpri Chinchwad to Mumbai Taxi Service",
description: "Pimpri Chinchwad to Mumbai taxi service offers dependable transportation with experienced drivers and comfortable vehicles. Passengers can travel safely between PCMC and Mumbai via the expressway with punctual pickup services. Pickup services are available from homes, offices, hotels, and railway stations across Pimpri Chinchwad. Flexible booking options allow convenient ride reservations."
}
],

tableData: [
["Pimpri Chinchwad to Mumbai Airport Cab","Pimpri to Mumbai Airport Cab Charges"],
["Pimpri Chinchwad to Mumbai One Way Cab","PCMC to Mumbai Taxi Service"],
["PCMC to Mumbai Drop Taxi Service","Pimpri Chinchwad to Mumbai Innova Taxi Fare"],
["Chinchwad to Mumbai Airport Cab","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Pimpri Chinchwad to Mumbai Cab Booking"],
["Chinchwad to Mumbai Cab","Chinchwad to Mumbai Airport Drop"],
["Pimpri Chinchwad to Mumbai Cab Booking Online","Cab Service in Pune"],
["Pune to Mumbai Airport Cab","Pune Mumbai Cab"],
["Pimpri Chinchwad to Mumbai Cab","Pimpri Chinchwad to Mumbai Taxi"],
["Pimpri Chinchwad to Mumbai Cab Service","Pimpri Chinchwad to Mumbai Taxi Service"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Velocity Cabs provides skilled drivers who regularly travel between Pimpri Chinchwad and Mumbai via the Mumbai Pune Expressway. Their knowledge of traffic routes and highway driving ensures a safe and smooth intercity journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Pimpri Chinchwad to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming their ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Pimpri Chinchwad to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, business trip, or late night ride, Velocity Cabs ensures reliable transportation."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Pimpri Chinchwad to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pimpri Chinchwad",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and industrial areas across Pimpri Chinchwad including Pimpri, Chinchwad, Wakad, Nigdi, Bhosari, and Akurdi."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Pimpri Chinchwad to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Pimpri Chinchwad to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Pimpri Chinchwad to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Pimpri Chinchwad to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Pimpri Chinchwad to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pimpri Chinchwad to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Pimpri Chinchwad and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, offices, hotels, and industrial locations across Pimpri Chinchwad." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Pimpri Chinchwad to Mumbai cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Deshmukh",
    feedback:
      "A smooth and comfortable journey from Pimpri Chinchwad to Mumbai. The cab was punctual, clean, and the ride felt relaxed throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "The Pimpri Chinchwad to Mumbai cab service was very reliable. The vehicle was well-maintained, the drive was steady, and the entire travel experience felt safe and hassle-free.",
    rating: 5
  }
];











































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pimpri Chinchwad to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs offers reliable Pimpri Chinchwad to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis from PCMC to Mumbai including sedan, Ertiga, Innova, and Innova Crysta for airport transfers and outstation travel. Enjoy safe, comfortable, and punctual rides with easy booking options.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};








  return (
    <div>
      

<Helmet>
  <title>Pimpri Chinchwad to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Pimpri Chinchwad to Mumbai cab with Velocity Cabs. Affordable taxi service from PCMC to Mumbai with sedan, Ertiga, Innova & Crysta. Safe, reliable & comfortable cab booking for airport and outstation travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Pimprichichwadtomumbaicab;